export default __webpack_public_path__ + "static/media/intro-original.27d13c21.jpg";